import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { ParkingCardInfoResponse } from '../../../../../../core/models/parking.model';
import { ApiTransactionParkingService } from '../../../../../../core/services/api/parking/api-transaction-parking.service';

@Component({
  selector: 'app-modal-transaction-parking-member-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-transaction-parking-member-card.component.html',
  styleUrl: './modal-transaction-parking-member-card.component.css',
  animations: [
    trigger('backdropAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0 }))
      ])
    ]),
    trigger('modalAnimation', [
      transition(':enter', [
        style({ transform: 'scale(0.95)', opacity: 0 }),
        animate('300ms cubic-bezier(0.16, 1, 0.3, 1)', style({ transform: 'scale(1)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'scale(0.95)', opacity: 0 }))
      ])
    ])
  ]
})
export class ModalTransactionParkingMemberCardComponent implements OnInit {

  /** จากช่อง บัตร / สมาชิก ใน detail */
  @Input() cardName: string | null = null;
  /** site ของธุรกรรม */
  @Input() siteId: number | null = null;
  @Output() close = new EventEmitter<void>();

  memberData: ParkingCardInfoResponse | null = null;
  isLoading = false;
  error: string | null = null;

  private readonly apiService = inject(ApiTransactionParkingService);

  ngOnInit(): void {
    const name = this.cardName?.trim() || '';
    const site = Number(this.siteId) || 0;
    if (site > 0 && name) {
      this.loadMemberInfo(site, name);
    } else {
      this.error = 'ไม่พบ site หรือชื่อบัตรของธุรกรรมนี้';
    }
  }

  loadMemberInfo(siteId: number, cardName: string): void {
    this.isLoading = true;
    this.error = null;
    this.memberData = null;

    this.apiService.getParkingCardInfoByCardName(siteId, cardName).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (!res?.cardCode && !res?.cardName) {
          this.error = 'ไม่พบข้อมูลบัตรสมาชิก';
          return;
        }
        this.memberData = {
          ...res,
          parkingRenewHistories: res.parkingRenewHistories ?? [],
        };
      },
      error: (err) => {
        console.error('Error loading member info:', err);
        this.error = 'ไม่สามารถโหลดข้อมูลบัตรสมาชิกได้';
        this.isLoading = false;
      }
    });
  }

  get displayHolderName(): string {
    return this.memberData?.fullName?.trim()
      || this.memberData?.cardName?.trim()
      || '-';
  }

  retryLoad(): void {
    const name = this.cardName?.trim() || '';
    const site = Number(this.siteId) || 0;
    if (site > 0 && name) {
      this.loadMemberInfo(site, name);
    }
  }

  onClose(): void {
    this.close.emit();
  }
}
